import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import {
  fetchWebhooks, fetchEventosWebhook, criarWebhook, atualizarWebhook,
  removerWebhook, testarWebhook, fetchEntregasWebhook,
} from '../../api/webhooks';
import './Webhooks.css';

const ROTULO_EVENTO = {
  chamado_criado: 'Chamado criado',
  chamado_status_alterado: 'Status alterado',
  chamado_atribuido: 'Chamado atribuído',
  sla_risco: 'SLA em risco',
  sla_violado: 'SLA violado',
};
const FORM_INICIAL = { id: null, nome: '', url: '', eventos: [], ativo: true };

function Webhooks() {
  const history = useHistory();
  const [lista, setLista] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(FORM_INICIAL);
  const [show, setShow] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [entregas, setEntregas] = useState({});

  const verificar = useCallback(async () => {
    const ok = await verificandoApp('ATENDENTE');
    if (!ok) history.push('/');
  }, [history]);

  const carregar = useCallback(async () => {
    verificandoToken();
    setLoading(true);
    const [l, e] = await Promise.all([fetchWebhooks(), fetchEventosWebhook()]);
    setLista(l); setEventos(e); setLoading(false);
  }, []);

  useEffect(() => { verificar(); carregar(); }, [verificar, carregar]);

  const abrirNovo = () => { setForm(FORM_INICIAL); setShow(true); setMensagem(''); };
  const abrirEditar = (w) => {
    setForm({ id: w.id, nome: w.nome, url: w.url, eventos: w.eventos === '*' ? ['*'] : (w.eventos || []), ativo: w.ativo });
    setShow(true); setMensagem('');
  };

  const toggleEvento = (ev) => {
    setForm((f) => ({ ...f, eventos: f.eventos.includes(ev) ? f.eventos.filter((x) => x !== ev) : [...f.eventos, ev] }));
  };

  const salvar = async () => {
    setMensagem('');
    if (!form.nome.trim()) { setMensagem('Informe um nome.'); return; }
    if (!/^https?:\/\//i.test(form.url)) { setMensagem('URL inválida (use http:// ou https://).'); return; }
    setSalvando(true);
    try {
      const body = { nome: form.nome.trim(), url: form.url.trim(), eventos: form.eventos, ativo: form.ativo };
      if (form.id) await atualizarWebhook(form.id, body);
      else {
        const r = await criarWebhook(body);
        if (r?.data?.segredo) setMensagem('Webhook criado. Segredo de assinatura: ' + r.data.segredo);
      }
      setShow(false);
      await carregar();
    } catch (e) {
      setMensagem(e?.response?.data?.error || 'Erro ao salvar webhook.');
    } finally { setSalvando(false); }
  };

  const excluir = async (w) => {
    if (!window.confirm(`Excluir o webhook "${w.nome}"?`)) return;
    try { await removerWebhook(w.id); carregar(); } catch (_) {}
  };

  const testar = async (w) => {
    setMensagem('Enviando teste para ' + w.nome + '…');
    try {
      const r = await testarWebhook(w.id);
      setMensagem(r && r.sucesso ? `Teste OK (HTTP ${r.statusCode}).` : `Falha no teste: ${r?.erro || ('HTTP ' + (r?.statusCode || '?'))}.`);
      verEntregas(w.id);
    } catch (e) { setMensagem(e?.response?.data?.error || 'Erro ao testar.'); }
  };

  const verEntregas = async (id) => {
    const e = await fetchEntregasWebhook(id);
    setEntregas((prev) => ({ ...prev, [id]: e }));
  };

  const rotuloEventos = (ev) => {
    if (ev === '*' || (Array.isArray(ev) && ev.includes('*'))) return 'Todos os eventos';
    if (!Array.isArray(ev) || ev.length === 0) return 'Nenhum evento';
    return ev.map((x) => ROTULO_EVENTO[x] || x).join(', ');
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado webhooks-page">
          <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div>
              <h1 className="mb-0"><i className="fas fa-bolt me-2" />Webhooks</h1>
              <p className="text-muted small mb-0">Receba notificações HTTP quando eventos ocorrem (chamado criado, SLA, etc.). O corpo é assinado com HMAC-SHA256 no cabeçalho <code>X-Tacoma-Signature</code>.</p>
            </div>
            <button type="button" className="btn btn-primary btn-sm" onClick={abrirNovo}><i className="fas fa-plus me-1" />Novo webhook</button>
          </div>

          {mensagem && <div className="alert alert-info py-2 mt-2">{mensagem}</div>}

          {loading ? <p className="text-muted">Carregando…</p> : lista.length === 0 ? (
            <div className="alert alert-info py-3 mt-2">Nenhum webhook configurado.</div>
          ) : (
            <table className="table table-modern align-middle mt-2">
              <thead><tr><th>Nome</th><th>URL</th><th>Eventos</th><th>Ativo</th><th style={{ width: 220 }}>Ações</th></tr></thead>
              <tbody>
                {lista.map((w) => (
                  <React.Fragment key={w.id}>
                    <tr>
                      <td>{w.nome}</td>
                      <td className="webhooks-url">{w.url}</td>
                      <td className="small">{rotuloEventos(w.eventos)}</td>
                      <td><span className={`badge-pill ${w.ativo ? 'badge-ativo' : 'badge-inativo'}`}>{w.ativo ? 'Sim' : 'Não'}</span></td>
                      <td>
                        <button type="button" className="btn btn-outline-secondary btn-sm me-1" onClick={() => testar(w)} title="Enviar teste"><i className="fas fa-paper-plane" /></button>
                        <button type="button" className="btn btn-outline-secondary btn-sm me-1" onClick={() => verEntregas(w.id)} title="Ver entregas"><i className="fas fa-list" /></button>
                        <button type="button" className="btn btn-secondary btn-sm me-1" onClick={() => abrirEditar(w)} title="Editar"><i className="fas fa-edit" /></button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => excluir(w)} title="Excluir"><i className="fas fa-trash" /></button>
                      </td>
                    </tr>
                    {entregas[w.id] && (
                      <tr className="webhooks-entregas-row">
                        <td colSpan="5">
                          <div className="webhooks-entregas">
                            <strong className="small">Últimas entregas</strong>
                            {entregas[w.id].length === 0 ? <span className="text-muted small ms-2">Nenhuma entrega ainda.</span> : (
                              <ul>
                                {entregas[w.id].map((e, i) => (
                                  <li key={i} className={e.sucesso ? 'ok' : 'fail'}>
                                    <i className={`fas ${e.sucesso ? 'fa-check' : 'fa-times'} me-1`} />
                                    {e.evento} · {e.status_code != null ? 'HTTP ' + e.status_code : (e.erro || 'erro')} · {new Date(e.criado_em).toLocaleString('pt-BR')}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}

          {show && (
            <div className="webhooks-modal-overlay" onClick={() => setShow(false)}>
              <div className="webhooks-modal" onClick={(e) => e.stopPropagation()}>
                <h5>{form.id ? 'Editar webhook' : 'Novo webhook'}</h5>
                <div className="form-group mb-2">
                  <label>Nome</label>
                  <input type="text" className="form-control form-control-sm" value={form.nome} onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))} maxLength={120} />
                </div>
                <div className="form-group mb-2">
                  <label>URL de destino</label>
                  <input type="text" className="form-control form-control-sm" placeholder="https://exemplo.com/webhook" value={form.url} onChange={(e) => setForm((f) => ({ ...f, url: e.target.value }))} maxLength={500} />
                </div>
                <div className="form-group mb-2">
                  <label>Eventos</label>
                  <div className="webhooks-eventos">
                    <label className="webhooks-evento-chip">
                      <input type="checkbox" checked={form.eventos.includes('*')} onChange={() => toggleEvento('*')} /> Todos
                    </label>
                    {eventos.map((ev) => (
                      <label key={ev} className="webhooks-evento-chip">
                        <input type="checkbox" checked={form.eventos.includes(ev)} disabled={form.eventos.includes('*')} onChange={() => toggleEvento(ev)} />
                        {ROTULO_EVENTO[ev] || ev}
                      </label>
                    ))}
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label className="d-flex align-items-center gap-2">
                    <input type="checkbox" checked={form.ativo} onChange={(e) => setForm((f) => ({ ...f, ativo: e.target.checked }))} /> Ativo
                  </label>
                </div>
                <div className="webhooks-modal-acoes">
                  <button type="button" className="btn btn-link btn-sm" onClick={() => setShow(false)}>Cancelar</button>
                  <button type="button" className="btn btn-primary btn-sm" onClick={salvar} disabled={salvando}>{salvando ? 'Salvando…' : 'Salvar'}</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default Webhooks;
